import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { MetadataService } from 'src/app/services/metadata-service.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.page.html',
  styleUrls: ['./gallery.page.scss'],
})
export class GalleryPage implements OnInit, OnDestroy {
  private _id = this.route.snapshot.paramMap.get('id');
  public gallery = undefined;
  public relation: any[] = [];
  public products: any[] = [];
  private _domainId = environment.domainId;
  public reloadObs = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private httpSv: HttpService,
    private metaDataSv: MetadataService,
    private paramSv: ParamServicesService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.reloadObs.add(
      this.paramSv.reload.subscribe(() => {
        this.getGallery();
      })
    );
  }

  async ngOnInit() {
    this.getGallery();
  }

  async getGallery() {
    try {
      this.httpSv.loadingIndicatorSrc.next(true);
      const res: any = await this.httpSv.getProduct(
        `${this._id}/${this._domainId}`,
        'gallery'
      );
      this.httpSv.loadingIndicatorSrc.next(false);
      const data = res;
      this.gallery = data.gallery;
      this.gallery.sponsor = this.gallery?.sponsorImagesId;
      if (this.gallery.sponsor) {
        this.gallery.type = 'sponsor';
      }
      const img = this.gallery.media[0]?.file;
      this.gallery.image = `${environment.url}/file/gallerie/${img}`;
      this.gallery.serverUrl = `${environment.url}`;
      this.relation = data.relation;
      this.products = data.products;
      await this.metaDataSv.updateMetadata(this.gallery, undefined);
    } catch (err) {
      console.error(err);
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.reloadObs.unsubscribe();
    }
  }
}
